import { useI18n } from "../i18n";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { t, lang, setLanguage } = useI18n();
  const [open, setOpen] = useState(false);

  const nav = [
    { id: "approach", label: t("nav.approach"), href: "/#approach" },
    { id: "portfolio", label: t("nav.portfolio"), href: "/#portfolio" },
    { id: "platform", label: t("nav.platform"), href: "/piattaforma" },
    { id: "method", label: t("nav.method"), href: "/metodo" },
    { id: "stories", label: t("nav.stories"), href: "/case-studies" },
    { id: "insights", label: t("nav.insights"), href: "/insights" },
    { id: "pricing", label: t("nav.pricing"), href: "/prezzi" },
    { id: "about", label: t("nav.about"), href: "/chi-siamo" },
    { id: "contact", label: t("nav.contact"), href: "/#contact" },
  ];

  return (
    <header
      className="sticky top-0 z-40"
      style={{
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        background: "rgba(247,245,240,0.82)",
        borderBottom: "1px solid var(--border)",
      }}
      data-testid="site-header"
    >
      <div className="container-x flex items-center justify-between" style={{ height: 72 }}>
        <Link to="/" data-testid="brand-link" className="flex items-baseline gap-2">
          <span className="serif-display" style={{ fontSize: 28, letterSpacing: "-0.03em" }}>
            GIANO
          </span>
          <span className="overline" style={{ color: "var(--terracotta)" }}>·1954</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <a
              key={n.id}
              href={n.href}
              data-testid={`nav-${n.id}`}
              className="text-sm font-medium hover:opacity-60 transition-opacity"
              style={{ color: "var(--midnight)" }}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="hidden md:flex items-center gap-1 font-mono text-xs">
            <button
              data-testid="lang-it"
              onClick={() => setLanguage("it")}
              className="px-1 transition-opacity"
              style={{ opacity: lang === "it" ? 1 : 0.4, fontWeight: lang === "it" ? 600 : 400 }}
            >
              IT
            </button>
            <span style={{ opacity: 0.3 }}>/</span>
            <button
              data-testid="lang-en"
              onClick={() => setLanguage("en")}
              className="px-1 transition-opacity"
              style={{ opacity: lang === "en" ? 1 : 0.4, fontWeight: lang === "en" ? 600 : 400 }}
            >
              EN
            </button>
          </div>
          <a href="#contact" className="btn-primary hidden md:inline-flex" data-testid="header-cta">
            {t("cta.sell")}
          </a>
          <button
            className="md:hidden"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t" style={{ borderColor: "var(--border)" }} data-testid="mobile-menu">
          <div className="container-x py-6 flex flex-col gap-4">
            {nav.map((n) => (
              <a key={n.id} href={n.href} onClick={() => setOpen(false)} className="text-lg font-medium">
                {n.label}
              </a>
            ))}
            <div className="flex items-center gap-2 font-mono text-xs pt-2">
              <button onClick={() => setLanguage("it")} style={{ opacity: lang === "it" ? 1 : 0.4 }}>IT</button>
              <span>/</span>
              <button onClick={() => setLanguage("en")} style={{ opacity: lang === "en" ? 1 : 0.4 }}>EN</button>
            </div>
            <a href="#contact" className="btn-primary" onClick={() => setOpen(false)}>{t("cta.sell")}</a>
          </div>
        </div>
      )}
    </header>
  );
}
